import { borderDangerBase } from './colors';

// Input
export const inputBorderRest = 'rgba(0, 0, 0, 0.38)';
export const inputBorderError = borderDangerBase;
